import type { SelfView } from "@bezbolisno/contracts/telegram";
import { t } from "@bezbolisno/i18n";
import { packageStatus } from "./labels";
import { Section } from "./Section";

/** Bought packages and how much of each is left. */
export function PackageList({ packages }: { packages: SelfView["packages"] }) {
  return (
    <Section title={t.telegram.packages}>
      {packages.length === 0 ? (
        <div className="tg-hint">{t.packages.empty}</div>
      ) : (
        packages.map((p) => {
          const used = Math.min(p.visitsUsed, p.visitsTotal);
          const pct = p.visitsTotal > 0 ? Math.round((used / p.visitsTotal) * 100) : 0;
          return (
            <div key={p.id} style={{ padding: "0.5rem 0" }}>
              <div className="tg-row" style={{ minHeight: "2rem", padding: 0 }}>
                <span>{p.title}</span>
                <span className={p.status === "active" ? "tg-chip" : "tg-chip tg-chip--muted"}>
                  {packageStatus(p.status)}
                </span>
              </div>
              <div className="tg-bar" style={{ margin: "0.375rem 0 0.25rem" }}>
                <div className="tg-bar__fill" style={{ width: `${pct}%` }} />
              </div>
              <div className="tg-hint tg-num" style={{ fontSize: "0.8125rem" }}>
                {t.packages.visitsOf(p.visitsUsed, p.visitsTotal)}
              </div>
            </div>
          );
        })
      )}
    </Section>
  );
}
